<script setup lang="ts" generic="T extends keyof ResourceFields">
import { ResourceFields, usePermissionStore } from "@/stores/permission";

defineProps<{
	resource: T;
	field: keyof ResourceFields[T];
}>();

const permissionStore = usePermissionStore();
</script>

<template>
	<slot v-if="permissionStore.hasFieldEditPermission(resource, field)" />
	<slot v-else name="fallback" />
</template>
